import { Button, IconSvg } from '@wome/ui'
import React from 'react'

import s from './styles.module.scss'

import { useRegenerateAuthenticateTokenMutation } from '@/lib/graphql'

import PageLayout from '../page'

const RegenerateToken = () => {
  const {
    mutateAsync: requestNewAccess,
    data,
    isLoading,
  } = useRegenerateAuthenticateTokenMutation()

  const handleRequestNewAccess = async () => {
    if (window?.location?.href) {
      await requestNewAccess({ url: window.location.href })
    }
  }

  return (
    <PageLayout isAuthenticateTokenExpired={true}>
      <div className={s.container}>
        <div className={s.imageWrapper}>
          <img
            alt='mail'
            src='/images/new-link/mail-icon-and-naboo-logo.png'
            className={s.image}
          />
        </div>

        {data?.regenerateAuthenticateToken?.success !== true ? (
          <>
            <p className={s.text}>
              Le lien vers votre espace hôte a expiré. Cliquez ci-dessous pour
              obtenir un nouveau lien.
            </p>
            <Button
              loading={isLoading}
              onClick={handleRequestNewAccess}
              className={s.button}
            >
              Recevoir un nouveau lien
            </Button>
          </>
        ) : (
          <div className={s.successTextWrapper}>
            <IconSvg.IconCheckCircle className={s.icon} color='green' />
            <p className={s.successText}>
              Un nouveau lien vous a été envoyé, consultez votre boîte mail pour
              y accéder.{' '}
            </p>
          </div>
        )}
      </div>
    </PageLayout>
  )
}

export default RegenerateToken
